/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_FailedInputs */

const he_verify_failed = /** @type {(inputs: Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האימות נכשל`)
};

const en_verify_failed = /** @type {(inputs: Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification Failed`)
};

/**
* | output |
* | --- |
* | "Verification Failed" |
*
* @param {Verify_FailedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const verify_failed = /** @type {((inputs?: Verify_FailedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_FailedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_verify_failed(inputs)
	return en_verify_failed(inputs)
});